<div class="types-container">
  <div *ngFor="let value of categories" class="type-element">{{ value }}</div>
</div>
